import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const METRICS = [
  { id: "metric-impl", value: "647", label: "Zoho One implementations since 2017" },
  { id: "metric-admin", value: "25–40%", label: "less admin time across those engagements" },
  { id: "metric-roi", value: "6–8×", label: "typical ROI within 18–24 months" },
];

export default function SocialProof() {
  return (
    <section className="py-20 lg:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="col-span-12 lg:col-span-6">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-teal font-semibold mb-4">
                What changes
              </p>
              <h2 className="font-display font-semibold tracking-tight leading-[1.12] text-brand-navy text-2xl sm:text-3xl lg:text-4xl mb-10">
                The numbers behind the promise.
              </h2>
            </Reveal>

            <div data-testid="social-proof-metrics" className="space-y-0">
              {METRICS.map((m, i) => (
                <Reveal key={m.id} delay={i * 0.08}>
                  <div
                    data-testid={m.id}
                    className="flex items-baseline gap-6 py-6 border-t border-slate-200 last:border-b"
                  >
                    <span className="font-display font-bold text-3xl sm:text-4xl text-brand-golddeep w-32 shrink-0">
                      {m.value}
                    </span>
                    <span className="text-base text-slate-600">{m.label}</span>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.2}>
              <figure data-testid="client-testimonial-card" className="mt-12 max-w-lg">
                <Quote size={22} className="text-brand-teal mb-4" />
                <blockquote className="font-display text-lg sm:text-xl text-brand-navy leading-snug mb-4">
                  "In six weeks our team's RFI response time dropped 43%.
                  Decisions now happen in hours, not days."
                </blockquote>
                <figcaption className="text-sm text-slate-500">
                  Director of Operations, Horizon Construction ·{" "}
                  <a href="/journal/horizon-construction-case-study" data-testid="testimonial-case-link" className="font-semibold text-brand-teal hover:text-brand-navy transition-colors">
                    read the full case study →
                  </a>
                </figcaption>
              </figure>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="col-span-12 lg:col-span-6">
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2rem] bg-brand-tealsoft -rotate-1" />
              <img
                src="https://images.pexels.com/photos/8469988/pexels-photo-8469988.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Construction and engineering team reviewing project plans together"
                width="940"
                height="650"
                loading="lazy"
                decoding="async"
                className="relative rounded-[1.75rem] w-full h-[380px] sm:h-[480px] object-cover shadow-[0_30px_60px_-20px_rgba(14,20,51,0.3)]"
              />
              <p className="mt-4 text-xs text-slate-400">
                Real outcomes from Bruno's client engagements since 2017.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
